// extracted by mini-css-extract-plugin
export default {"host":"style_host__uFcB2","resizing":"style_resizing__d7QMX","toggle":"style_toggle__tvdXw","content":"style_content__tOHzf","closed":"style_closed__56ZJa"};